module.exports = __webpack_public_path__ + "img/STM2.5050719c.jpg";